var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7789 4.62778L19.1664 2.59444C18.9889 2.47937 18.7958 2.39068 18.5933 2.33111C18.3917 2.26464 18.1816 2.22796 17.9696 2.22222H10.45L11.3311 7.77778H17.9696C18.15 7.77778 18.3755 7.73667 18.5922 7.66889C18.8089 7.60111 19.0179 7.50778 19.1653 7.40667L21.7778 5.37111C21.9263 5.27 22 5.13556 22 5C22 4.86444 21.9263 4.73 21.7789 4.62778ZM9.35 0H8.25C8.10413 0 7.96424 0.0585316 7.86109 0.162718C7.75795 0.266905 7.7 0.408213 7.7 0.555556V4.44444H4.0304C3.8478 4.44444 3.6234 4.48556 3.4067 4.55444C3.1889 4.62111 2.981 4.71333 2.8336 4.81667L0.2211 6.85C0.0726 6.95111 0 7.08667 0 7.22222C0 7.35667 0.0726 7.49111 0.2211 7.59444L2.8336 9.63C2.981 9.73111 3.1889 9.82445 3.4067 9.89111C3.6234 9.95889 3.8478 10 4.0304 10H7.7V19.4444C7.7 19.5918 7.75795 19.7331 7.86109 19.8373C7.96424 19.9415 8.10413 20 8.25 20H9.35C9.49587 20 9.63576 19.9415 9.73891 19.8373C9.84205 19.7331 9.9 19.5918 9.9 19.4444V0.555556C9.9 0.408213 9.84205 0.266905 9.73891 0.162718C9.63576 0.0585316 9.49587 0 9.35 0Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.a67a02665f5c30b6c5eda755844a22da.svg";
export { ForwardRef as ReactComponent };